import { useLocation, useNavigate } from 'react-router-dom';
import {
	HiHome,
	HiBriefcase,
	HiVideoCamera,
	HiOutlineUserGroup,
	HiUserGroup,
	HiOutlineUsers,
	HiUsers,
	HiOutlineBriefcase,
	HiOutlineOfficeBuilding,
	HiOfficeBuilding,
	HiOutlineHome,
	HiOutlineClipboardCheck,
	HiClipboardCheck,
	HiCalendar,
	HiOutlineCalendar,
} from 'react-icons/hi';
import { MdOutlineChangeCircle, MdOutlinePublishedWithChanges } from "react-icons/md";
import { FiMoreHorizontal } from 'react-icons/fi';
import { BiCodeBlock } from 'react-icons/bi';
import { isRecruiterSide, isUniversitySide } from 'src/config/env.config';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import { useEffect, useState } from 'react';
import { useUserContext } from 'src/context/UserProvider';
import { FaListCheck, FaListUl } from 'react-icons/fa6';
import { PiTrophyFill } from 'react-icons/pi';
import classNames from 'classnames';
import { UserExperienceLevelType } from 'types';
import { Button } from '@mui/material';
import { useGetMyRegisteredDrives } from 'src/hooks/offlineDrive.hooks';

const Footer = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { user } = useUserContext();
	const { isAccountManagerLoggedIn, isUserUniversityManagerLoggedIn, isDriveAdminLoggedIn, isJobseekerLoggedIn } = useUserContext();
	const { data: myRegisteredDrives } = useGetMyRegisteredDrives({ enabled: isJobseekerLoggedIn });
	const { companies, selectedCompany, selectedPositionId } = useRecommendationsContext();

	const [activeCompany, setActiveCompany] = useState<string>();
	const [activePosition, setActivePosition] = useState<string>();

	// On Scroll up show nav
	// useEffect(() => {
	// 	const body = document.body;
	// 	const scrollUp = 'scroll-up';
	// 	const scrollDown = 'scroll-down';
	// 	let lastScroll = 0;
	// 	const scrollThreshold = 100; // Adjust this threshold to your preferred scroll amount

	// 	body.classList.remove(scrollDown);
	// 	body.classList.remove(scrollUp);

	// 	const handleScroll = () => {
	// 		const currentScroll = window.scrollY;

	// 		if (currentScroll <= scrollThreshold) {
	// 			body.classList.remove(scrollUp);
	// 			return;
	// 		}

	// 		if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
	// 			// down
	// 			body.classList.remove(scrollUp);
	// 			body.classList.add(scrollDown);
	// 		} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
	// 			// up
	// 			body.classList.remove(scrollDown);
	// 			body.classList.add(scrollUp);
	// 		}

	// 		lastScroll = currentScroll;
	// 	};

	// 	window.addEventListener('scroll', handleScroll);

	// 	return () => {
	// 		lastScroll = 0;
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, [location.pathname]);

	useEffect(() => {
		if (selectedCompany?.company && selectedCompany?.company?.positions) {
			setActiveCompany(selectedCompany?.company?._id);
			setActivePosition(selectedPositionId);
		} else if (!selectedCompany?.company) {
			const openComp = companies.find(c => c.activePositions > 1);
			setActiveCompany(openComp?.company._id);
			setActivePosition(
				selectedPositionId || (openComp?.company.positions ? openComp?.company.positions[0]?._id ?? '' : ''),
			);
		}
	}, [selectedCompany?.company, selectedPositionId, companies]);

	const isPositionsRoute = isAccountManagerLoggedIn
		? location.pathname.includes('my-positions')
		: location.pathname === '/positions';

	const footerOptions =
		isUserUniversityManagerLoggedIn && isUniversitySide
			? [
				{
					show: isUserUniversityManagerLoggedIn,
					icon:
						location.pathname.startsWith('/') && location.pathname.endsWith('/')
							? HiOfficeBuilding
							: HiOutlineOfficeBuilding,
					page_name: 'Dashboard',
					pushTo: `/`,
					disabled: false,
					activeStyling:
						location.pathname.startsWith('/') && location.pathname.endsWith('/')
							? '!text-[#7777E7]'
							: '!text-[#555770] dark:!text-[#C7C9D9]',
					testId: 'footer-link-companies',
				},
				{
					show: true,
					icon: location.pathname.includes('/student-reports') ? HiUserGroup : HiOutlineUserGroup,
					page_name: 'Student Reports',
					pushTo: `/student-reports`,
					disabled: false,
					activeStyling: location.pathname.includes('/student-reports')
						? '!text-[#7777E7]'
						: '!text-[#555770] dark:!text-[#C7C9D9]',
					testId: 'footer-link-candidates',
				},
			]
			: isRecruiterSide
				? isDriveAdminLoggedIn
					? [
						{
							show: isDriveAdminLoggedIn,
							icon: location.pathname.includes('/offline-drive-candidates') ? HiUsers : HiOutlineUsers,
							page_name: 'Candidates',
							pushTo: `/offline-drive-candidates`,
							disabled: false,
							activeStyling: location.pathname.includes('/offline-drive-candidates')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-offline-candidates',
						},
						{
							show: isDriveAdminLoggedIn,
							icon: location.pathname.includes('/offline-drive-companies')
								? HiOfficeBuilding
								: HiOutlineOfficeBuilding,
							page_name: 'Companies',
							pushTo: `/offline-drive-companies`,
							disabled: false,
							activeStyling: location.pathname.includes('/offline-drive-companies')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-offline-companies',
						},
						{
							show: isDriveAdminLoggedIn,
							icon: location.pathname.includes('/update-phone-number')
								? MdOutlinePublishedWithChanges
								: MdOutlineChangeCircle
							,
							page_name: 'User Updates',
							pushTo: `/update-phone-number`,
							disabled: false,
							activeStyling: location.pathname.includes('/update-phone-number')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-offline-companies',
						},
						{
							show: isDriveAdminLoggedIn,
							icon: location.pathname.includes('/add-drive-room')
								? MdOutlinePublishedWithChanges
								: MdOutlineChangeCircle
							,
							page_name: 'Add Room',
							pushTo: `/add-drive-room`,
							disabled: false,
							activeStyling: location.pathname.includes('/add-drive-room')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-offline-companies',
						}
					]
					: [
						{
							show: !isAccountManagerLoggedIn,
							icon: location.pathname.includes('/select-hiring-type') ? HiHome : HiOutlineHome,
							page_name: 'Home',
							pushTo: `/select-hiring-type`,
							disabled: false,
							activeStyling: location.pathname.includes('/select-hiring-type')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-hiring-type',
						},
						{
							show: !isAccountManagerLoggedIn,
							icon: location.pathname.includes('/recruiter-dashboard') ? HiClipboardCheck : HiOutlineClipboardCheck,
							page_name: 'Dashboard',
							pushTo: `/recruiter-dashboard`,
							disabled: false,
							activeStyling: location.pathname.includes('/recruiter-dashboard')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-dashboard',
						},
						{
							show: true,
							icon: location.pathname.includes('/drive-positions') ? HiCalendar : HiOutlineCalendar,
							page_name: 'P. Drive',
							pushTo: `/drive-positions`,
							disabled: false,
							activeStyling: location.pathname.includes('/drive-positions')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-drive-positions',
						},
						{
							show: !isAccountManagerLoggedIn,
							icon: location.pathname.includes('support') ? HiUsers : HiOutlineUsers,
							page_name: 'Support',
							pushTo: `/support`,
							disabled: false,
							activeStyling: location.pathname.includes('support')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-support',
						},
						{
							show: isAccountManagerLoggedIn,
							icon: location.pathname.includes('/companies') ? HiOfficeBuilding : HiOutlineOfficeBuilding,
							page_name: 'Companies',
							pushTo: `/companies`,
							disabled: isAccountManagerLoggedIn ? activeCompany && activePosition : activePosition,
							activeStyling: location.pathname.includes('/companies')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-companies',
						},
						{
							show: isAccountManagerLoggedIn,
							icon: location.pathname.includes('/positions') ? HiUserGroup : HiOutlineUserGroup,
							page_name: 'Candidates',
							pushTo: `/positions/${isAccountManagerLoggedIn ? `${activeCompany}/` : ''}${activePosition}/candidates`,
							disabled: isAccountManagerLoggedIn ? activeCompany && activePosition : activePosition,
							activeStyling: location.pathname.includes('/positions/')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-candidates',
						},
						{
							show: isAccountManagerLoggedIn,
							icon: location.pathname.includes('pipeline') ? FaListCheck : FaListUl,
							page_name: 'Pipeline',
							pushTo: `/pipeline/${isAccountManagerLoggedIn ? `${activeCompany}/` : ''}${activePosition}`,
							disabled: isAccountManagerLoggedIn ? activeCompany && activePosition : activePosition,
							activeStyling: location.pathname.includes('pipeline')
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-pipeline',
						},
						{
							show: isAccountManagerLoggedIn,
							icon: isPositionsRoute ? HiBriefcase : HiOutlineBriefcase,
							page_name: 'Positions',
							pushTo: `/${isAccountManagerLoggedIn ? `my-positions/${activeCompany}` : 'positions'}`,
							disabled: isAccountManagerLoggedIn ? activeCompany : true,
							activeStyling: isPositionsRoute ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
							testId: 'footer-link-positions',
						},
					]
				: [
					{
						show: true,
						icon: HiHome,
						page_name: 'Home',
						pushTo: '/',
						disabled: false,
						// activeStyling: location.pathname === '/dashboard' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
						activeStyling: location.pathname === '/my-applications' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
						testId: 'footer-link-home',
					},
					// {
					// 	show: true,
					// 	icon: HiVideoCamera,
					// 	page_name: 'Tech Rounds',
					// 	pushTo: '/interviews',
					// 	disabled: false,
					// 	activeStyling: location.pathname === '/interviews' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
					// 	testId: 'footer-link-interviews',
					// },
					// {
					// 	show: true,
					// 	icon: PiTrophyFill,
					// 	page_name: 'Contests',
					// 	pushTo: '/contests',
					// 	disabled: false,
					// 	activeStyling:
					// 		location.pathname === '/contests' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
					// 	testId: 'footer-link-contests',
					// },
					// {
					// 	show: true,
					// 	icon: HiBriefcase,
					// 	page_name: 'Jobs',
					// 	pushTo: '/jobs',
					// 	disabled: false,
					// 	activeStyling: location.pathname === '/jobs' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
					// 	testId: 'footer-link-jobs',
					// },
					// {
					// 	show: true,
					// 	icon: BiCodeBlock,
					// 	page_name: 'Challenges',
					// 	pushTo: '/challenges',
					// 	disabled: false,
					// 	activeStyling:
					// 		location.pathname === '/challenges' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
					// 	testId: 'footer-link-challenges',
					// },
					{
						show:
							user?.userPreference?.experienceLevel !== UserExperienceLevelType.FINAL_YEAR_STUDENT &&
							!!myRegisteredDrives?.drives?.length,
						icon:
							location.pathname === '/offline-drive-day-opportunities' ||
							location.pathname === '/offline-drive-attendance'
								? HiCalendar
								: HiOutlineCalendar,
						page_name: 'Drive',
						pushTo: '/offline-drive-day-opportunities',
						disabled: false,
						activeStyling:
							location.pathname === '/offline-drive-day-opportunities' ||
							location.pathname === '/offline-drive-attendance'
								? '!text-[#7777E7]'
								: '!text-[#555770] dark:!text-[#C7C9D9]',
						testId: 'footer-link-drive',
					},
					{
						show: true,
						icon: HiOutlineClipboardCheck,
						page_name: 'Dashboard',
						pushTo: '/user-dashboard',
						disabled: false,
						activeStyling:
							location.pathname === '/user-dashboard' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
						testId: 'footer-link-dashboard',
					},
					{
						show: true,
						icon: FiMoreHorizontal,
						page_name: 'More',
						pushTo: '/more-options',
						disabled: false,
						activeStyling:
							location.pathname === '/more-options' ? '!text-[#7777E7]' : '!text-[#555770] dark:!text-[#C7C9D9]',
						testId: 'footer-link-more-options',
					},
				];

	return (
		<>
			<div className="nav-mobile transition-all fixed bottom-0 left-0 flex w-full justify-evenly bg-white dark:bg-[#18222D] shadow-up">
				{footerOptions
					.filter(el => el.show)
					.map((option, index) => (
						<Button
							variant="text"
							onClick={() => {
								console.log('option.pushTo:', option.pushTo);
								console.log('option.disabled:', option.disabled);
								// if (!option.disabled) {
								navigate(option.pushTo);
								// }
							}}
							sx={{
								borderRadius: '0px',
								paddingY: '9px',
							}}
							key={index}
							className={classNames(
								`my-[9px] flex flex-1 flex-col items-center justify-center cursor-pointer`,
								option.activeStyling,
							)}
						>
							<option.icon data-testid={option.testId} size={'22px'} className="flex" />
							<p className="!text-center !text-[10px] font-[400]">{option.page_name}</p>
						</Button>
					))}
			</div>
		</>
	);
};

export default Footer;
